$w.onReady(function () {
    $w("#dynamicDataset").onReady(() => {
        const item = $w("#dynamicDataset").getCurrentItem();

        if (item && item.text1) {
            const htmlContent = item.text1;  
            $w("#html1").postMessage(htmlContent);
        } else {
            console.warn("Data not loaded yet");
        }
    });


});
